import React, { useState, useRef, useEffect } from 'react';
import { useOutsideClick } from '@hooks/useOutsideClick';
import { CategoryList } from './components/CategoryList';
import { SubCategoriesList } from './components/SubCategoriesList';
import { useReset } from './Select.hooks';
import { getComputerName } from '@helpers/stringHelpers';
import { SelectItem } from './Select.types';
import './Select.scss';

interface List {
  [key: string]: Array<SelectItem> | string;
  Id: string;
  Name: string;
}

interface SelectProps {
  name: string;
  sub: string;
  resetTime?: number | null;
  selectFunction: (item: SelectItem) => void;
  defaultTitle: string;
  selectableTitle?: boolean;
  title: string;
  list: List[];
  label?: string;
  backLabel?: string;
  required?: boolean;
}

export const Select = ({
  name,
  sub,
  resetTime,
  selectFunction,
  defaultTitle,
  selectableTitle,
  required = false,
  title,
  list,
  label = '',
  backLabel,
}: SelectProps) => {
  const [isShowing, setIsShowing] = useState<boolean>(false);
  const [selectedCategory, setSelectedCategory] = useState<SelectItem[]>(null);
  const [selectedCategoryItem, setSelectedCategoryItem] = useState<SelectItem>(null);

  const doReset = () => {
    setIsShowing(false);
    setSelectedCategory(null);
    setSelectedCategoryItem(null);
  };

  useReset(resetTime, doReset);

  useEffect(() => {
    doReset();
  }, [list]);

  const selectRef = useRef<HTMLDivElement>(null);
  const handleClickOutside = () => {
    setIsShowing(false);
  };
  useOutsideClick(selectRef, handleClickOutside);

  const handleClick = () => {
    setIsShowing(!isShowing);
  };

  const selectCategory = (category: SelectItem[]) => {
    setSelectedCategory(category);
  };

  const selectCategoryItem = (item: SelectItem) => {
    selectFunction(item);
    setSelectedCategoryItem(item);
    setIsShowing(false);
    setSelectedCategory(null);
  };

  const onClickSelectableTitle = () => {
    if (selectableTitle) {
      selectFunction(null);
      doReset();
    }
  };

  const back = () => {
    setSelectedCategory(null);
  };

  return (
    <div ref={selectRef} className='c-select'>
      {label && (
        <label htmlFor={getComputerName(label)}>
          {label}
          {required && ' *'}
        </label>
      )}

      <div className='c-button'>
        <div className='c-select-wrapper' data-name={getComputerName(label)} onClick={handleClick}>
          <span>{selectedCategoryItem ? selectedCategoryItem[name] : title}</span>
          <i className='icon-angle-down' />
        </div>
        {isShowing && (
          <div className='c-select-list'>
            <ul>
              {!selectedCategory ? (
                <CategoryList
                  name={name}
                  sub={sub}
                  list={list}
                  onSelect={selectCategory}
                  selectableTitle={selectableTitle}
                  onClickSelectableTitle={onClickSelectableTitle}
                  defaultTitle={defaultTitle}
                />
              ) : (
                <SubCategoriesList
                  name={name}
                  list={selectedCategory}
                  backLabel={backLabel}
                  onClickBack={back}
                  onSelect={selectCategoryItem}
                />
              )}
            </ul>
          </div>
        )}
      </div>
    </div>
  );
};
